$(".close_popup").click(function(){
 $('.newsletter-popup').removeClass('popup_open')
 $('body').removeClass('body_popup_open')
  
})
$('.v-announcement-bar').click(function(){
 $('.newsletter-popup').addClass('popup_open')
 $('body').addClass('body_popup_open')
  
  
})
// $('.mobile_buttons').on('click touchstart', function() {
//   console.log('test');
//   $('.product-form__submit').trigger('click');
// });




 // document.addEventListener("DOMContentLoaded", function () {
 //    const items = document.querySelectorAll("li.grid__item");

 //    items.forEach(function (item) {
 //      const media = item.querySelector(".media.jjj");
 //      if (!media) return;

 //      const images = media.querySelectorAll("img");
 //      if (images.length >= 2) {
 //        const img1 = images[0];
 //        const img2 = images[1];

 //        // Default state
 //        img1.style.translate = "none";
 //        img1.style.rotate = "none";
 //        img1.style.scale = "none";
 //        img1.style.transform = "translate(0px, 0px)";

 //        img2.style.translate = "none";
 //        img2.style.rotate = "none";
 //        img2.style.scale = "none";
 //        img2.style.transform = "translate(125%, 0%)";

 //        // Hover in
 //        item.addEventListener("mouseenter", function () {
 //          img1.style.transform = "translate(-125%, 0%) translate3d(0px, 0px, 0px)";
 //          img2.style.transform = "translate(0px, 0px)";
 //        });

 //        // Hover out
 //        item.addEventListener("mouseleave", function () {
 //          img1.style.transform = "translate(0px, 0px)";
 //          img2.style.transform = "translate(125%, 0%)";
 //        });
 //      }
 //    });
 //  });





// for loader spinner for first visit only

  // document.addEventListener("DOMContentLoaded", function () {
  //   const LOADER_KEY = 'loaderShownAt';
  //   const HOURS_BEFORE_SHOW_AGAIN = 24;
  //   const now = Date.now();
  //   const loaderEl = document.querySelector(".loader");
  //   const loadingScreenEl = document.querySelector(".loading_screen");

  //   function shouldShowLoader() {
  //     const stored = localStorage.getItem(LOADER_KEY);
  //     if (!stored) return true;
  //     const diffHours = (now - parseInt(stored, 10)) / (1000 * 60 * 60);
  //     return diffHours >= HOURS_BEFORE_SHOW_AGAIN;
  //   }

  //   if (shouldShowLoader()) {
  //     //alert("First visit: Loader will show.");

  //     setTimeout(() => {
  //       if (loaderEl) loaderEl.style.display = "none";
  //       if (loadingScreenEl) loadingScreenEl.style.display = "none";
  //       localStorage.setItem(LOADER_KEY, now.toString());
  //     }, 3000); // Adjust to match animation duration
  //   } else {
  //     if (loaderEl) loaderEl.style.display = "none";
  //     if (loadingScreenEl) loadingScreenEl.style.display = "none";
  //   }
  // });





// document.addEventListener("DOMContentLoaded", function () {
//   const marqueeInner = document.querySelector(".product_title_marquee_inner");
//   if (!marqueeInner) return;

//   marqueeInner.style.display = "flex";
//   marqueeInner.style.animation = "scroll-marquee 20s linear infinite";
// });


